var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTruck24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "truck"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 18V6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V17C2 17.2652 2.10536 17.5196 2.29289 17.7071C2.48043 17.8946 2.73478 18 3 18H5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15 18H9",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19 18H21C21.2652 18 21.5196 17.8946 21.7071 17.7071C21.8946 17.5196 22 17.2652 22 17V13.35C21.9996 13.1231 21.922 12.903 21.78 12.726L18.3 8.376C18.2065 8.25888 18.0878 8.16428 17.9528 8.0992C17.8178 8.03412 17.6699 8.00021 17.52 8H14",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19 18C19 19.1046 18.1046 20 17 20C15.8954 20 15 19.1046 15 18C15 16.8954 15.8954 16 17 16C18.1046 16 19 16.8954 19 18Z",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18Z",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTruck24);
export default __webpack_public_path__ + "static/media/icon-truck-24.ad9a9adcbf1b0183d6e79299c27a6d72.svg";
export { ForwardRef as ReactComponent };